import { useQuery } from "@tanstack/react-query";
import { graphicsAPI, GraphicsCategory } from "../api";

// Get all graphics items
export const useGetGraphicsItems = () => {
  return useQuery({
    queryKey: ["graphicsItems"],
    queryFn: () => graphicsAPI.getAllItems(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get graphics items by category
export const useGetGraphicsItemsByCategory = (category: GraphicsCategory) => {
  return useQuery({
    queryKey: ["graphicsItems", category],
    queryFn: () => graphicsAPI.getItemsByCategory(category),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get single graphics item by ID
export const useGetGraphicsItemById = (id: string) => {
  return useQuery({
    queryKey: ["graphicsItem", id],
    queryFn: () => graphicsAPI.getItemById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook to organize items by category
export const useGetGraphicsItemsGrouped = () => {
  const { data: items, ...rest } = useGetGraphicsItems();

  const groupedItems = items ? groupItemsByCategory(items) : null;

  return {
    ...rest,
    data: groupedItems,
  };
};

// Helper function to group items by category
const groupItemsByCategory = (items: any[]) => {
  return items.reduce((acc, item) => {
    const category = item.category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});
};
